import table from './table'

export default {
    title: 'Anfrage',
    active: 'Anfrage aktiv',
    closed: 'Anfrage geschlossen',
    overview: 'Übersicht',
    offerSubmitted: 'Angebot abgegeben',
    noOfferSubmitted: 'Kein Angebot abgegeben',
    request: 'Anfrage',
    requestedLineItems: 'Angefragte Positionen',
    itemsToOffer: 'Bestellwunsch',
    tenderNumber: 'Anfragenummer',
    tenderingPerson: 'Antragsteller',
    recipient:'Warenempfänger',
    visibleUntil: 'Sichtbar bis',
    category: 'Kategorie',
    order: 'Beschaffung',
    tenderingActive: 'Angebotswahl offen',
    offerAccepted: 'Angebot angenommen',
    offerSelected: 'Anderes Angebot ausgewählt',

    offer: {
        title: 'Angebot',
        create: 'Angebot anlegen / bearbeiten',
    },
    emailSubject: '[BEMA] Nachfrage zu Ihrer Anfrage {tender} vom {date}',
    positionDocument: 'Positionsdokument',
    updateOffer: 'Angebot anpassen',
    createOffer: 'Angebot abgeben',
    withdrawOffer: 'Angebot zurückziehen',
    mustRepresentsCompany: 'Angebote zu Anfragen können nur im Namen eines Unternehmens abgegeben werden.',
    withdrawOfferConfirm: 'Angebot wirklich zurückziehen? Dadurch gehen alle Angebotsdaten verloren. Angebote können neu erstellt oder bearbeitet werden.',

    tenderingActiveInfo: 'Für diese Beschaffung werden aktuell Angebote angefragt. Sie können für Ihre Firma ein Angebot abgeben und dieses bis zum Ende der Angebotsfrist bearbeiten.',
    offerSelectedInfo: 'Sie haben für diese Beschaffung bereits ein Angebot abgegeben. Die Anfrage ist abgeschlossen und die beschaffende Person hat ein anderes Angebot angenommen.',
    offerAcceptedInfo: 'Ihr abgegebenes Angebot wurde durch die beschaffende Person angenommen. Sie können Ihr Angebot nicht mehr bearbeiten.',
    offerCreatedInfo: 'Sie haben für diese Beschaffung bereits ein Angebot abgegeben. Die Anfrage ist abgeschlossen. Die Auswahl eines Angebots durch die beschaffende Person steht noch aus.',

    positions: {
        title: 'Positionen',
        number: 'Nr.',
        description: 'Beschreibung / Artikelnummer',
        quantity: 'Anzahl',
        unitPrice: 'Einzelpreis',
        quantityUnit: 'Einheit',
        priceType: 'Brutto/Netto',
        taxRate: 'MwSt.',
        price: 'Preis',
    },

    table
}